import { render, staticRenderFns } from "./IndexFooter.vue?vue&type=template&id=e56ca1de&scoped=true"
import script from "./IndexFooter.vue?vue&type=script&lang=js"
export * from "./IndexFooter.vue?vue&type=script&lang=js"
import style0 from "./IndexFooter.vue?vue&type=style&index=0&id=e56ca1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56ca1de",
  null
  
)

export default component.exports